//
// Error thrown in place of sending a request while the session is being closed.
//
// The `suspended` marker tells a caller its call was cancelled client-side,
// not refused by the server.
//
const requestSuspendedError = (target) => {
  const error = new Error(`request suspended while logging out: ${target}`);

  error.suspended = true;

  return error;
};

export default requestSuspendedError;
